<script setup>
import { useStateStore } from '@/stores/state.store'
import ButtonDefault from './atoms/ButtonDefault.vue'
import ProductDisplay from '@/components/Shopify/ProductDisplay.vue'
import { ref, onMounted, onBeforeUnmount } from 'vue'
import eventBus from '@/eventBus'
import { useCart } from '@/router/cart'
import { useShopify } from '@/stores/shopify'
import { onClickOutside } from '@vueuse/core'
import { storeToRefs } from 'pinia'

const { openCart } = useCart()
const shopify = useShopify()
const state = useStateStore()
const { selectedProduct } = storeToRefs(state)
const logo = '/home/img/wyrld-logo.png'

const productPanel = ref(null)

const close = () => {
  eventBus.$emit('product-panel-closed')
  state.popProduct()
}

onMounted(() => {
  eventBus.$on('cart-added-items', () => {
    openCart()
    close()
  })
})

onBeforeUnmount(() => {
  eventBus.$off('cart-added-items')
})

onClickOutside(productPanel, () => {
  if (selectedProduct.value != undefined) {
    close()
  }
})
</script>

<template>
  <div v-if="selectedProduct" class="product-panel-outer" ref="productPanel">

    <div class="product-panel-header">
      <div class="header__logo">
        <img :src="logo" width="100"/>
      </div>
      <div class="header__right">
        <ButtonDefault
          icon="Cart"
          icon-only
          class="cart__button"
          :badge="shopify.cartLines"
          @click="openCart"
        />
        <ButtonDefault icon="Close" icon-only @click="close" />
      </div>
    </div>

    <ProductDisplay :product="selectedProduct" />

  </div>
</template>

<style lang="scss" scoped>

/* PDP PopOver */
.product-panel-header {

  height: 60px;
  padding: 0 20px;
  width: calc(100dvw - 30px) !important;
  max-width: 600px;
  z-index: 1000;
  top: 0;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  box-shadow: 0 -2px 12px 0 rgba(36, 38, 53, 0.12);

  position: fixed;
  top: 15px;
  right: 15px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  background-color: white;
}
.product-panel-header .header__logo {
    position: fixed;
    left: 22px;
    top: 12px;
}

.product-panel-header .header__right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 32px;
    height: 100%;
}

</style>
